module.exports = __webpack_public_path__ + "static/media/nurse.0435d853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse.png
// module id = 486
// module chunks = 0